import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
// EmailJS removed - using AWS Lambda instead
import './Contact.css';

// Import images
import mailHeroImage from '../assets/images/mail.jpg';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    // Reset status when user starts typing
    if (submitStatus) setSubmitStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const lambdaUrl = process.env.REACT_APP_LAMBDA_CONTACT_URL;

    if (!lambdaUrl) {
      console.error('Lambda URL yapılandırması eksik!');
      setIsSubmitting(false);
      setSubmitStatus('error');
      return;
    }

    try {
      const response = await fetch(lambdaUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        }),
      });

      // Check if response is ok
      if (!response.ok) {
        let errorMessage = 'Mesaj gönderilirken bir hata oluştu.';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (e) {
          // If response is not JSON, get text
          const errorText = await response.text();
          errorMessage = errorText || `HTTP ${response.status}: ${response.statusText}`;
        }
        throw new Error(errorMessage);
      }

      // Try to parse response, but if CORS error, assume success if status is 200
      let data;
      try {
        data = await response.json();
      } catch (e) {
        // If CORS error but status is 200, assume success
        if (response.status === 200) {
          data = { success: true, message: 'Mesajınız başarıyla gönderildi!' };
        } else {
          throw e;
        }
      }

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      setTimeout(() => setSubmitStatus(null), 3000);
    } catch (error) {
      console.error('Lambda Error:', error);
      setSubmitStatus('error');
      setTimeout(() => setSubmitStatus(null), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact">
      <Helmet>
        <title>ProgenX İletişim | Bize Ulaşın</title>
        <meta name="description" content="ProgenX ile iletişime geçin. Sorularınız, iş birliği teklifleriniz veya bilgi almak istediğiniz konular için formu doldurabilir veya doğrudan bizimle iletişime geçebilirsiniz. ODTÜ Teknokent'teki ofisimize bekleriz." />
        <meta name="keywords" content="progenx iletişim, progenx adres, progenx telefon, progenx e-posta, progenx konum, progenx iletişim formu" />
        <link rel="canonical" href="https://progenxacademy.com/iletisim" />
      </Helmet>
      
      <Hero 
        title="İLETİŞİM" 
        backgroundImage={mailHeroImage}
      />
      
      <section className="contact-content">
        <div className="container">
          <div className="contact-info">
            <h2 className="section-title">Bize Ulaşın</h2>

            
            <div className="contact-details">
              <div className="contact-item">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
                <div>
                  <h3>Adres</h3>
                  <p>ODTÜ TEKNOKENT<br />Çankaya/Ankara</p>
                </div>
              </div>
              
              <div className="contact-item">
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <div>
                  <h3>Telefon</h3>
                  <p>+90 (538) 686 54 16</p>
                </div>
              </div>
              
              <div className="contact-item">
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <div>
                  <h3>E-posta</h3>
                  <p className="contact-email">info@progenxacademy.com</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-map">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3060.9092978286926!2d32.77336567550136!3d39.89866298700865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d3473bf835ba7b%3A0x865a1c85b2604198!2sProgenx%20E%C4%9Fitim%20ve%20Bili%C5%9Fim%20Teknolojileri%20A.%C5%9E.!5e0!3m2!1str!2str!4v1744320513224!5m2!1str!2str" 
              width="100%" 
              height="450" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="ProgenX Konum"
            ></iframe>
          </div>
          
          <div className="contact-form-container">
            <h3 className="form-title">Mesaj Gönder</h3>
            {submitStatus === 'success' && (
              <div className="form-message success">
                <FontAwesomeIcon icon={faCheckCircle} />
                <span>İletildi</span>
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="form-message error">
                <span>İletilemedi</span>
              </div>
            )}
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Adınız Soyadınız</label>
                <input 
                  type="text" 
                  id="name"
                  name="name" 
                  placeholder="Adınız Soyadınız" 
                  value={formData.name} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">E-posta Adresiniz</label>
                <input 
                  type="email" 
                  id="email"
                  name="email" 
                  placeholder="ornek@email.com" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Konu</label>
                <input 
                  type="text" 
                  id="subject"
                  name="subject" 
                  placeholder="Mesajınızın konusu" 
                  value={formData.subject} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Mesajınız</label>
                <textarea 
                  id="message"
                  name="message" 
                  placeholder="Mesajınızı buraya yazın..." 
                  value={formData.message} 
                  onChange={handleChange} 
                  required 
                  rows="6"
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="btn btn-primary" 
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <FontAwesomeIcon icon={faSpinner} spin /> Gönderiliyor...
                  </>
                ) : (
                  'GÖNDER'
                )}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 